import React from 'react';
import { renderToString } from 'react-dom/server';
import { StatusPage } from 'components';

/**
 * Performs emergency maintenance to handle an application crash, working outside of the react lifecycle.
 *
 * @method handleCrashDetected
 */
const handleCrashDetected = () => {
  // Clear CacheStorage
  console.log(
    'The app crashed. Clearing all offline application and book resources from CacheStorage.',
  );
  caches.keys().then((keys) => keys.map((key) => caches.delete(key)));

  // Render error message
  document.body.innerHTML = renderToString(<StatusPage></StatusPage>);
};

export default handleCrashDetected;
